import { Link } from 'react-router';
import { useDocumentTitle } from '../hooks/use-document-title';

export function NotFoundPage() {
  useDocumentTitle('Página não encontrada');
  return (
    <section className="forbidden-state" aria-labelledby="nf-title">
      <h1 id="nf-title" className="page-title">
        Página não encontrada
      </h1>
      <p>O endereço acessado não existe ou foi movido.</p>
      <Link className="btn btn--secondary" to="/">
        Voltar ao início
      </Link>
    </section>
  );
}
